import gql from 'graphql-tag'

export default gql`
  fragment DraftPostDocuments on DraftPost {
    documents {
      title
      type
      id
    }
  }
`
